import {
  register,
  CloudObject,
  InstanceOrTag,
  Transaction,
  defineProperty,
  BrickContext,
  Property,
  Query,
  Predicate,
} from 'olympe';

export type SecretsKeys = {
  DOMAIN: string;
  API_KEY: string;
  TENANT: string;
};

export class Secrets extends CloudObject {
  static keyProp: Property<string>;
  static valueProp: Property<string>;

  static create(transaction: Transaction) {
    return transaction.create(Secrets);
  }

  getKey() {
    return this.get<string>(Secrets.keyProp);
  }

  observeKey($: BrickContext) {
    return this.observe($, Secrets.keyProp);
  }

  getValue(): string {
    return this.get<string>(Secrets.valueProp);
  }

  observeValue($: BrickContext) {
    return this.observe($, Secrets.valueProp);
  }

  static setKey(transaction: Transaction, instance: InstanceOrTag, value: string) {
    transaction.update(instance, Secrets.keyProp, value);
  }

  static setValue(transaction: Transaction, instance: InstanceOrTag, value: string) {
    transaction.update(instance, Secrets.valueProp, value);
  }

  static async find(key: string, $: BrickContext): Promise<string | undefined> {
    const query = Query.instancesOf(Secrets).filter(
      Predicate.contains(Secrets.keyProp, key, false)
    );
    const secret: Secrets | undefined = (await query.execute()).toArray()[0];

    return secret?.getValue();
  }

  static async findAll($: BrickContext): Promise<SecretsKeys> {
    const secrets: Secrets[] = (
      await Query.instancesOf(Secrets).execute()
    ).toArray();

    return secrets.reduce(
      (acc, secret) => {
        acc = {
          ...acc,
          [secret.getKey()]: secret.getValue(),
        };

        return acc;
      },
      { DOMAIN: '', API_KEY: '', TENANT: '' }
    );
  }
}

// Hardcoded tags
register('01899b6eed558b564734', Secrets);
Secrets.keyProp = defineProperty('01899b6eed552727c9a2');
Secrets.valueProp = defineProperty('01899b6eed5535cacd33');
